import { Polish as PolishLocale } from 'flatpickr/dist/l10n/pl'
import { computed, ref } from '@vue/composition-api'
import dayjs from 'dayjs'
import flatpickr from 'flatpickr'
import { $themeBreakpoints } from '@themeConfig'
import store from '@/store'

export default (props, { emit }) => {
  const dateRange = props.value
  const maxMonthsNumber = props.maxMonthsNumber ? props.maxMonthsNumber : null
  const dateRangePickerRef = ref()
  const dateRangeDropdownRef = ref()
  const me = store.getters['auth/getUser']
  const organizationCreatedAt = computed(() => dayjs(me.organization.createdAt))
  let flatpickrObject = null

  const resolveMonthsNumber = () => {
    if ($themeBreakpoints.lg > store.state.app.windowWidth) {
      return 1
    }

    return maxMonthsNumber
  }

  const configDateTimePicker = {
    locale: PolishLocale,
    disableMobile: true,
    dateFormat: 'd.m.Y',
    inline: true,
    showMonths: resolveMonthsNumber(),
    mode: 'range',
    static: true,
    onChange: dates => {
      if (dates.length === 2) {
        dateRange.value = dates
        emit('input', dateRange.value)
      }
    },
  }

  const applyDateRangePicker = (fromDate, range, rangeUnits) => {
    const from = fromDate.startOf('day')
    const to = from.add(range, rangeUnits).subtract(1, 'second')

    flatpickrObject.setDate([from.toDate(), to.toDate()], true)
  }

  const onDateRangePickerShown = () => {
    flatpickrObject = flatpickr(dateRangePickerRef.value, configDateTimePicker)
    flatpickrObject.setDate(props.value)
  }

  const toggleDropdown = () => {
    dateRangeDropdownRef.value.show()
  }

  return {
    // variables
    dateRange,
    dateRangePickerRef,
    dateRangeDropdownRef,
    me,
    organizationCreatedAt,
    toggleDropdown,

    // methods
    dayjs,
    configDateTimePicker,
    onDateRangePickerShown,
    applyDateRangePicker,
  }
}
